import { createGenerateClassName } from "@material-ui/core";
import { StylesProvider, ThemeProvider } from "@material-ui/core/styles";
import { DefaultTheme } from "@material-ui/styles";
import { WbCard } from "./components/WbCard/WbCard";
import { WbCardContent } from "./components/WbCard/WbCardContent";
import { parseDescriptor } from "./utilities/descriptorParser";
import DataQualityDashboard from "./components/HistoricalDataSection/DataQualityDashboard";
import { env } from './env'
import { useEffect } from "react";

interface Props {
  theme: DefaultTheme;
  descriptor: any;
  outputport: any;
  token: string;
}

function App({ theme, descriptor, outputport, token }: Props) {

  const entity = parseDescriptor(descriptor, outputport);
  
  useEffect(() => {
    fetch('/env.js').then((response) => { console.log(response); })
  },[]);

  return (
    <StylesProvider
      injectFirst
      generateClassName={createGenerateClassName({ productionPrefix: "dqd" })}
    >
      <ThemeProvider theme={theme}>
        <WbCard title="Data Quality Dashboard">
          <WbCardContent>
            <div style={{ display: "flex", flexDirection: "column", gap: 30 }}>
                <DataQualityDashboard entity={entity} token={token} forwardEndpoint={env.REACT_APP_FORWARD_ENDPOINT} />
            </div>
          </WbCardContent>
        </WbCard>
      </ThemeProvider>
    </StylesProvider>
  );
}

export default App;